export default __webpack_public_path__ + "a86170e1cff9269ed7bd46b56841c3fb.svg";